<template>
  <div class="agilityResultContainer">
    <div :class="`agilityResultIcon ${type}`">
      <Icon :type="resultInfos[type].icon || 'ios-checkmark'"></Icon>
    </div>
    <div class="agilityResultTitle" v-if="title">{{title}}</div>
    <div class="agilityResultDesc">
      <slot name="desc">
        <!-- 提交结果页用于反馈一系列操作任务的处理结果，如果仅是简单操作，使用 Message 全局提示反馈即可。灰色区域可以显示一些补充的信息。 -->
        {{desc}}
      </slot>
    </div>
    <div class="agilityResultExtra" v-if="extra">
      <slot name="extra">
        <!-- 其他补充信息，自带灰底效果 -->
        {{extra}}
      </slot>
    </div>
    <div class="agilityResultActions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'agilityResult',
  props: {
    type: {
      required: false,
      default: 'success'
    },
    title: {
      required: false,
      default: '提交成功'
    },
    desc: {
      required: false,
      default: ''
    },
    extra: {
      required: false,
      default: ''
    },
  },
  data () {
    return {
      resultInfos: {
        success: {
          icon: 'ios-checkmark'
        },
        error: {
          icon: 'ios-close',
        },
        warning: {
          icon: 'ios-information',
        }
      }
    }
  },

}
</script>
<style lang="less" scoped>
.agilityResultContainer {
  margin: 0 auto !important;
  text-align: center;
  padding: 1rem 0;

  .agilityResultIcon {
    color: #fff;
    display: inline-block;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    margin-bottom: 24px;

    > i {
      color: #fff;
      font-size: 5rem;
    }
  }

  .agilityResultIcon.success {
    background-color: #19be6b;
  }

  .agilityResultIcon.error {
    background-color: #ed4014;
  }

  .agilityResultIcon.warning {
    background-color: #f90;
  }

  .agilityResultTitle {
    margin-bottom: 1rem;
    color: #17233d;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .agilityResultDesc {
    margin-bottom: 24px;
    color: #808695;
    font-size: 0.875rem;
    line-height: 22px;
    padding: 1rem;
  }

  .agilityResultExtra {
    padding: 24px 40px;
    text-align: left;
    background: #f8f8f9;
    border-radius: 4px;
  }

  .agilityResultActions {
    margin-top: 32px;
  }
}
</style>